module.exports = __webpack_public_path__ + "img/MEPHeaderFull.1b337ef7.png";